import script from "./BdSeg001.vue?vue&type=script&lang=ts&setup=true"
export * from "./BdSeg001.vue?vue&type=script&lang=ts&setup=true"

import "./BdSeg001.vue?vue&type=style&index=0&id=155ed172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155ed172"]])

export default __exports__